// import React, { useEffect, useState } from "react";
// import axios from "../../api/axiosInstance";
// import { useNavigate } from "react-router-dom";
// import qr from "../../assets/qr.jpg";
// import toast, { Toaster } from "react-hot-toast";
// const MembershipPricingPage = () => {
//   const [offer, setOffer] = useState(null);
//   const [plans, setPlans] = useState([]);
//   const [selectedPlan, setSelectedPlan] = useState(null);
//   const [countdown, setCountdown] = useState("");
//   const [showModal, setShowModal] = useState(false);
//   const navigate = useNavigate();

//   useEffect(() => {
//     const fetchOfferAndPlans = async () => {
//       const offerRes = await axios.get("/api/memberships/offers/");
//       const planRes = await axios.get("/api/memberships/plans/");
//       if (offerRes.data.length > 0) setOffer(offerRes.data[0]);
//       setPlans(planRes.data);
//       if (planRes.data.length > 0) setSelectedPlan(planRes.data[0]);
//     };
//     fetchOfferAndPlans();
//   }, []);

//   useEffect(() => {
//     if (!offer) return;
//     const interval = setInterval(() => {
//       const now = new Date();
//       const end = new Date(offer.ends_at);
//       const diff = end - now;
//       if (diff <= 0) {
//         setCountdown("00:00:00");
//         clearInterval(interval);
//       } else {
//         const hours = String(
//           Math.floor((diff / (1000 * 60 * 60)) % 24)
//         ).padStart(2, "0");
//         const minutes = String(Math.floor((diff / (1000 * 60)) % 60)).padStart(
//           2,
//           "0"
//         );
//         const seconds = String(Math.floor((diff / 1000) % 60)).padStart(2, "0");
//         setCountdown(`${hours}:${minutes}:${seconds}`);
//       }
//     }, 1000);
//     return () => clearInterval(interval);
//   }, [offer]);

//   const handleSelectPlan = (plan) => {
//     setSelectedPlan(plan);
//   };
//   const handleConfirmPayment = async () => {
//     const storedUser = JSON.parse(localStorage.getItem("user"));
//     if (!storedUser) {
//       toast.error("User not found in session. Please login again.");
//       navigate("/login");
//       return;
//     }
//     try {
//       await axios.post("/api/memberships/purchase/", {
//         user: storedUser.id,
//         plan: selectedPlan.id,
//       });
//       toast.success("Membership activated successfully!");
//       setShowModal(false);
//       navigate("/profile");
//     } catch (error) {
//       toast.error("Failed to activate membership. Please contact support.");
//     }
//   };

//   const handlePayment = () => {
//     setShowModal(true);
//   };

//   return (
//     <div className="max-w-5xl mx-auto p-4 relative">
//       {offer && (
//         <div className="relative text-center mb-6">
//           <button
//             onClick={() => navigate("/profile")}
//             className="absolute top-2 right-2 text-gray-600 hover:text-gray-800 text-xl"
//           >
//             ✖
//           </button>
//           <h1 className="text-2xl font-bold text-pink-600">WELCOME OFFER</h1>
//           <p className="text-base text-gray-600 font-semibold mt-1">
//             Flat 68% OFF
//           </p>
//           <p className="text-3xl font-bold text-green-700">{offer.title}</p>
//           <div className="flex justify-center items-center gap-2 text-gray-700 mt-2">
//             <span>Offer Ends In {countdown}</span>
//           </div>
//         </div>
//       )}

//       {selectedPlan && (
//         <div className="bg-green-100 border border-green-300 rounded-lg p-4 mb-4 text-center">
//           <h2 className="text-lg font-semibold text-green-800 mb-2">
//             Features for {selectedPlan.name} Plan:
//           </h2>
//           <p className="text-green-700 text-sm whitespace-pre-line">
//             {selectedPlan.features.join(",\n")}
//           </p>
//         </div>
//       )}

//       <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mt-6">
//         {plans.map((plan) => (
//           <label
//             key={plan.id}
//             className={`relative rounded-xl border-2 shadow-sm p-5 flex flex-col items-center cursor-pointer transition ${
//               plan.best_selling ? "border-pink-500" : "border-gray-200"
//             } ${selectedPlan?.id === plan.id ? "ring-2 ring-pink-400" : ""}`}
//           >
//             <input
//               type="radio"
//               name="selectedPlan"
//               className="absolute top-2 left-2"
//               checked={selectedPlan?.id === plan.id}
//               onChange={() => handleSelectPlan(plan)}
//             />
//             {plan.best_selling && (
//               <div className="absolute top-2 right-2 bg-pink-600 text-white text-xs px-2 py-1 rounded">
//                 BEST SELLING
//               </div>
//             )}
//             <h3 className="text-lg font-bold text-gray-800">{plan.name}</h3>
//             <p className="text-sm text-gray-600">
//               {plan.duration_months > 0
//                 ? `${plan.duration_months} Months`
//                 : "Till You Marry"}
//             </p>
//             <p className="text-green-600 font-semibold mt-2">
//               SAVE {plan.save_percentage}%
//             </p>
//             <p className="line-through text-gray-500 mt-1">
//               ₹{parseInt(plan.original_price).toLocaleString()}
//             </p>
//             <p className="text-2xl font-bold text-gray-800 mt-1">
//               ₹{parseInt(plan.discounted_price).toLocaleString()}
//             </p>
//           </label>
//         ))}
//       </div>

//       {selectedPlan && (
//         <div className="text-center mt-6">
//           <button
//             onClick={handlePayment}
//             className="bg-pink-600 hover:bg-pink-700 text-white font-semibold py-2 px-6 rounded transition"
//           >
//             Proceed to Payment
//           </button>
//         </div>
//       )}

//       {showModal && (
//         <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
//           <div className="bg-white rounded-lg p-4 max-w-sm w-full relative">
//             <button
//               onClick={() => setShowModal(false)}
//               className="absolute top-2 right-2 text-gray-600 hover:text-gray-800"
//             >
//               ✖
//             </button>
//             <img
//               src={qr}
//               alt="QR Code for Payment"
//               className="w-full h-auto rounded mb-4"
//             />
//             <button
//               onClick={handleConfirmPayment}
//               className="bg-green-600 hover:bg-green-700 text-white w-full py-2 rounded"
//             >
//               Confirm Payment
//             </button>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

// export default MembershipPricingPage;

import React, { useEffect, useState } from "react";
import axios from "../../api/axiosInstance";
import { useNavigate } from "react-router-dom";
import qr from "../../assets/qr.jpg";
import toast from "react-hot-toast";

const MembershipPricingPage = () => {
  const [offer, setOffer] = useState(null);
  const [plans, setPlans] = useState([]);
  const [selectedPlan, setSelectedPlan] = useState(null);
  const [countdown, setCountdown] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [paymentScreenshot, setPaymentScreenshot] = useState(null);
  const [uploading, setUploading] = useState(false);
  const [hasPending, setHasPending] = useState(false);
  const [pendingPlan, setPendingPlan] = useState(null);

  const navigate = useNavigate();

  useEffect(() => {
    const fetchOfferAndPlans = async () => {
      const offerRes = await axios.get("/api/memberships/offers/");
      const planRes = await axios.get("/api/memberships/plans/");
      if (offerRes.data.length > 0) setOffer(offerRes.data[0]);
      setPlans(planRes.data);
      if (planRes.data.length > 0) setSelectedPlan(planRes.data[0]);
    };
    fetchOfferAndPlans();
  }, []);

  useEffect(() => {
    if (!offer) return;
    const interval = setInterval(() => {
      const now = new Date();
      const end = new Date(offer.ends_at);
      const diff = end - now;
      if (diff <= 0) {
        setCountdown("00:00:00");
        clearInterval(interval);
      } else {
        const hours = String(
          Math.floor((diff / (1000 * 60 * 60)) % 24),
        ).padStart(2, "0");
        const minutes = String(Math.floor((diff / (1000 * 60)) % 60)).padStart(
          2,
          "0",
        );
        const seconds = String(Math.floor((diff / 1000) % 60)).padStart(2, "0");
        setCountdown(`${hours}:${minutes}:${seconds}`);
      }
    }, 1000);
    return () => clearInterval(interval);
  }, [offer]);

  const handleSelectPlan = (plan) => {
    setSelectedPlan(plan);
  };

  const handlePayment = () => {
    setShowModal(true);
  };

  const handleFileChange = (e) => {
    if (e.target.files && e.target.files[0]) {
      setPaymentScreenshot(e.target.files[0]);
    }
  };

  const handleConfirmPayment = async () => {
    const storedUser = JSON.parse(localStorage.getItem("user"));
    if (!storedUser) {
      toast.error("User not found in session. Please login again.");
      navigate("/login");
      return;
    }

    if (!paymentScreenshot) {
      toast.error("Please upload payment screenshot before confirming.");
      return;
    }

    try {
      setUploading(true);
      const formData = new FormData();
      formData.append("user", storedUser.id);
      formData.append("plan", selectedPlan.id);
      formData.append("payment_screenshot", paymentScreenshot);

      await axios.post("/api/memberships/purchase/", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
        },
      });

      toast.success("Membership Selected successfully! Wait for Approved");
      setShowModal(false);
      navigate("/profile-html-php");
    } catch (error) {
      toast.error("Failed to activate membership. Please contact support.");
    } finally {
      setUploading(false);
    }
  };

  useEffect(() => {
    const checkPending = async () => {
      try {
        const res = await axios.get("/api/memberships/pending-check/", {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
          },
        });
        if (res.data.has_pending) {
          setHasPending(true);
          setPendingPlan(res.data.plan_name);
        }
      } catch (error) {
        console.error("Error checking pending status", error);
      }
    };
    checkPending();
  }, []);

  return (
    <div className="max-w-5xl mx-auto p-4 relative">
      {/* Offer Banner */}
      {offer && (
        <div className="relative text-center mb-6">
          <button
            onClick={() => navigate("/profile-html-php")}
            className="absolute top-2 right-2 text-gray-600 hover:text-gray-800 text-xl"
          >
            ✖
          </button>
          <h1 className="text-2xl font-bold text-pink-600">WELCOME OFFER</h1>
          <p className="text-base text-gray-600 font-semibold mt-1">
            Flat 68% OFF
          </p>
          <p className="text-3xl font-bold text-green-700">{offer.title}</p>
          <div className="flex justify-center items-center gap-2 text-gray-700 mt-2">
            <span>Offer Ends In {countdown}</span>
          </div>
        </div>
      )}

      {/* Selected Plan Features */}
      {selectedPlan && (
        <div className="bg-green-100 border border-green-300 rounded-lg p-4 mb-4 text-center">
          <h2 className="text-lg font-semibold text-green-800 mb-2">
            Features for {selectedPlan.name} Plan:
          </h2>
          <p className="text-green-700 text-sm whitespace-pre-line">
            {selectedPlan.features.join(",\n")}
          </p>
        </div>
      )}

      {/* Plans Selection */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mt-6">
        {plans.map((plan) => (
          <label
            key={plan.id}
            className={`relative rounded-xl border-2 shadow-sm p-5 flex flex-col items-center cursor-pointer transition ${
              plan.best_selling ? "border-pink-500" : "border-gray-200"
            } ${selectedPlan?.id === plan.id ? "ring-2 ring-pink-400" : ""}`}
          >
            <input
              type="radio"
              name="selectedPlan"
              className="absolute top-2 left-2"
              checked={selectedPlan?.id === plan.id}
              onChange={() => handleSelectPlan(plan)}
            />
            {plan.best_selling && (
              <div className="absolute top-2 right-2 bg-pink-600 text-white text-xs px-2 py-1 rounded">
                BEST SELLING
              </div>
            )}
            <h3 className="text-lg font-bold text-gray-800">{plan.name}</h3>
            <p className="text-sm text-gray-600">
              {plan.duration_months > 0
                ? `${plan.duration_months} Months`
                : "Till You Marry"}
            </p>
            <p className="text-green-600 font-semibold mt-2">
              SAVE {plan.save_percentage}%
            </p>
            <p className="line-through text-gray-500 mt-1">
              ₹{parseInt(plan.original_price).toLocaleString()}
            </p>
            <p className="text-2xl font-bold text-gray-800 mt-1">
              ₹{parseInt(plan.discounted_price).toLocaleString()}
            </p>
          </label>
        ))}
      </div>
      {hasPending && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
          <div className="bg-white rounded-lg p-6 max-w-sm w-full text-center relative">
            <button
              onClick={() => {
                setHasPending(false);
                navigate("/profile-html-php");
              }}
              className="absolute top-2 right-2 text-gray-600 hover:text-gray-800"
            >
              ✖
            </button>
            <h2 className="text-xl font-semibold text-pink-600 mb-3">
              Payment Under Review
            </h2>
            <p className="text-gray-700 mb-4">
              Your payment for the{" "}
              <span className="font-bold">{pendingPlan}</span> plan is under
              admin review. Your membership will be activated once approved.
            </p>
            <button
              onClick={() => navigate("/profile-html-php")}
              className="bg-pink-600 hover:bg-pink-700 text-white w-full py-2 rounded"
            >
              Go to Profile
            </button>
          </div>
        </div>
      )}

      {/* Proceed Button */}
      {selectedPlan && (
        <div className="text-center mt-6">
          <button
            onClick={handlePayment}
            className="bg-pink-600 hover:bg-pink-700 text-white font-semibold py-2 px-6 rounded transition"
          >
            Proceed to Payment
          </button>
        </div>
      )}

      {/* Modal */}
      {showModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
          <div className="bg-white rounded-lg p-4 max-w-sm w-64  relative">
            <button
              onClick={() => setShowModal(false)}
              className="absolute top-2 right-2 text-gray-600 hover:text-gray-800"
            >
              ✖
            </button>
            <img
              src={qr}
              alt="QR Code for Payment"
              className="w-68 h-auto rounded mb-4"
            />

            {/* Upload Screenshot Input */}
            <label>Upload payment ScreenShort</label>
            <input
              type="file"
              accept="image/*"
              onChange={handleFileChange}
              className="mb-4 w-48 border rounded px-3 py-2"
            />

            <button
              onClick={handleConfirmPayment}
              disabled={!paymentScreenshot || uploading || hasPending}
              className={`font-semibold py-2 px-6 rounded transition ${
                !paymentScreenshot || uploading || hasPending
                  ? "bg-gray-400 text-gray-700 cursor-not-allowed"
                  : "bg-pink-600 hover:bg-pink-700 text-white"
              }`}
            >
              {hasPending
                ? "Payment Approval Pending"
                : uploading
                  ? "Processing..."
                  : "Confirm Payment"}
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default MembershipPricingPage;
